// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__346E6","icon":"styles_icon__VymyP"};